class StoreService {
  refreshVirtualMachineList() {
    (window as any).VueGlobal.$store.dispatch('virtualMachines/getMachines', true);
  }
  getVirtualMachineListForWorkspace(workspaceId: any, regionId: any, isForced: boolean = false) {
    return (window as any).VueGlobal.$store.dispatch('virtualMachines/getMachinesForWorkspace', {
      workspaceId,
      regionId,
      forceUpdate: isForced,
    });
  }
  getVirtualMachineListForCurrentWorkspace(isForced: boolean = false) {
    (window as any).VueGlobal.$store.dispatch('virtualMachines/getMachines', isForced);
  }
  getWorkspaceMachine(virtualMachineId: any, workspaceId: any, regionId: any) {
    return (window as any).VueGlobal.$store.getters['virtualMachines/getWorkspaceMachine'](
      virtualMachineId,
      workspaceId,
      regionId
    );
  }
  getCurrentWorkspaceRole() {
    (window as any).VueGlobal.$store.dispatch('currentWorkspace/getWorkspaceUserRole', true);
  }
  addVirtualMachine(machine: any) {
    (window as any).VueGlobal.$store.dispatch('virtualMachines/addMachine', machine);
  }
  destroyVirtualMachine(payload: any) {
    (window as any).VueGlobal.$store.dispatch('virtualMachines/destroyMachine', payload);
  }
  updateVirtualMachineState(machine: { id: number; state: string }) {
    (window as any).VueGlobal.$store.dispatch('virtualMachines/updateMachineState', machine);
  }
  getVirtualMachineHardware(machineId: number, forceUpdate = false) {
    (window as any).VueGlobal.$store.dispatch('virtualMachines/getMachineHardware', { machineId, forceUpdate });
  }
  updateVirtualMachineHardware(payload: any) {
    (window as any).VueGlobal.$store.dispatch('virtualMachines/updateMachineHardware', payload);
  }
  updateVirtualMachineData(machine: { id: number; state: string }) {
    (window as any).VueGlobal.$store.dispatch('virtualMachines/updateMachineData', machine);
  }
  updateDedicatedMachineData(machine: { id: number; state: string }) {
    (window as any).VueGlobal.$store.dispatch('dedicatedMachines/updateMachineData', machine);
  }
  addDedicatedMachine(machine: any) {
    (window as any).VueGlobal.$store.dispatch('dedicatedMachines/addMachine', machine);
  }
  updateDedicatedMachineState(machine: { id: number; state: string }) {
    (window as any).VueGlobal.$store.dispatch('dedicatedMachines/updateMachineState', machine);
  }
  destroyDedicatedMachine(payload: any) {
    (window as any).VueGlobal.$store.dispatch('dedicatedMachines/destroyMachine', payload);
  }
  getDedicatedMachineList(isForced = true) {
    (window as any).VueGlobal.$store.dispatch('dedicatedMachines/getMachines', isForced);
  }
  updateWorkspaceUsers() {
    return (window as any).VueGlobal.$store.dispatch('workspaceUsers/getUsers');
  }
  getLimits(payload: any = null) {
    return (window as any).VueGlobal.$store.dispatch('currentWorkspace/getLimits', payload);
  }
  getCurrentUsage(payload: any = null) {
    return (window as any).VueGlobal.$store.dispatch('currentWorkspace/getCurrentUsage', payload);
  }
  updateWorkspaceName(payload: any = null) {
    return (window as any).VueGlobal.$store.dispatch('currentWorkspace/updateWorkspaceName', payload);
  }
  getWorkspaceName(payload: any = null) {
    return (window as any).VueGlobal.$store.dispatch('currentWorkspace/getWorkspaceName', payload);
  }
  getPublicAddresses() {
    return (window as any).VueGlobal.$store.dispatch('publicIPAddresses/getAddresses');
  }
  getPrivateNetworks() {
    return (window as any).VueGlobal.$store.dispatch('privateNetworks/getPrivateNetworks');
  }
  addPrivateNetwork(payload: any) {
    return (window as any).VueGlobal.$store.dispatch('privateNetworks/addPrivateNetwork', payload);
  }
  getPrivateNerworksListForCurrentWorkspace(isForced: boolean = false) {
    (window as any).VueGlobal.$store.dispatch('virtualMachines/getPrivateNetworks', isForced);
  }

  removePrivateNetwork(payload: any) {
    return (window as any).VueGlobal.$store.dispatch('privateNetworks/removePrivateNetwork', payload);
  }
  updatePrivateNetwork(payload: any) {
    return (window as any).VueGlobal.$store.dispatch('privateNetworks/updatePrivateNetwork', payload);
  }
  getNats() {
    return (window as any).VueGlobal.$store.dispatch('nats/getAllNats', true);
  }
  getNics(isForced: boolean = false) {
    return (window as any).VueGlobal.$store.dispatch('networkCards/getNetworkCards', isForced);
  }
  addNic(payload: any) {
    return (window as any).VueGlobal.$store.dispatch('networkCards/addNetworkCard', payload);
  }
  updateNic(payload: any) {
    return (window as any).VueGlobal.$store.dispatch('networkCards/updateNetworkCard', payload);
  }
  removeNic(payload: any) {
    return (window as any).VueGlobal.$store.dispatch('networkCards/removeNetworkCard', payload);
  }
  updateMachineNic(payload: any, type: string) {
    payload.modificationType = type;
    return (window as any).VueGlobal.$store.dispatch('virtualMachines/updateMachineNic', payload);
  }
  updateDedicatedNetworks(payload: any) {
    return (window as any).VueGlobal.$store.dispatch('dedicatedMachines/updateMachineNic', payload);
  }
  getDedicatedNics(isForced: boolean = false) {
    return (window as any).VueGlobal.$store.dispatch('dedicatedNetworkCards/getNetworkCards', isForced);
  }
  updateDedicatedNic(payload: any) {
    return (window as any).VueGlobal.$store.dispatch('dedicatedNetworkCards/updateNetworkCard', payload);
  }
  removeNats(ids: number[]) {
    return (window as any).VueGlobal.$store.commit('nats/removeNats', ids);
  }
  getRegions(isForced = false) {
    return (window as any).VueGlobal.$store.dispatch('regions/getRegions', isForced);
  }
  updateRegion(payload: any) {
    return (window as any).VueGlobal.$store.dispatch('regions/updateRegion', payload);
  }
  getSnapshot(vmId: any) {
    return (window as any).VueGlobal.$store.dispatch('snapshot/getSnapshot', vmId);
  }
  getSnapshotForced(vmId: any) {
    return (window as any).VueGlobal.$store.dispatch('snapshot/getSnapshotForced', vmId);
  }
  addSnapshot(vmId: any, payload: any) {
    return (window as any).VueGlobal.$store.commit('snapshot/addSnapshot', { id: vmId, data: payload });
  }
  updateSnapshot(vmId: any, payload: any) {
    return (window as any).VueGlobal.$store.commit('snapshot/updateSnapshot', { id: vmId, data: payload });
  }
  removeSnapshot(vmId: any) {
    return (window as any).VueGlobal.$store.commit('snapshot/removeSnap', vmId);
  }
  getWorkspaces() {
    return (window as any).VueGlobal.$store.dispatch('workspaces/getWorkspaces');
  }
  updateBillingPeriods(payload: any) {
    return (window as any).VueGlobal.$store.dispatch('billingPeriods/getBillingPeriods');
  }
}

export const storeService = new StoreService();
